export default __webpack_public_path__ + "static/media/img-0383-switzerland-full-face.1ab789ef.png";